const PbxxRecord = require('../pbxx_record')

module.exports = class RegistrationKey extends PbxxRecord {
  static get class_name() {
    return 'RegistrationKey'
  }
}
